module.exports = __webpack_public_path__ + "static/media/new_prestige_logo.31afc101.svg";